angular.module('jv.requisition.jobLink.controller', [])
.controller('ReqsJobLinkCtrl', ['$scope', '$http', '$window', 'Reqs',
function ($scope, $http, $window, Reqs) {
    $scope.url = '';
    $scope.jobLinkData = {};
    $scope.destinations = [{
        key: i18n.JOB_DESCRIPTION,
        value: 'cj',
        checked: true
    }, {
        key: i18n.JOB_APPLICATION,
        value: 'aj',
        checked: false
    }, {
        key: i18n.ALL_JOBS,
        value: 'bj',
        checked: false
    }];
    $scope.destination = {
        value: 'cj'
    };

    $scope.link = 'text';
    $scope.mode = 'existing';

    $scope.msgClass = '';
    $scope.showMessage = false;

    $scope.existingCrmSource = true;
    $scope.sourceRequiredError = false;
    $scope.crmSourceRequiredError = false;

    $scope.$watch('jobLinkModal.show', function (newValue) {
        if (newValue) {
            Reqs.getJobLinkSource(function(response) {
                $scope.jobLinkData = response;
            });
        }
    });
    var renderURL = function () {
        setTimeout(function() {
            $('#selectExistingSource').val($scope.selectedSource).trigger('change');
        }, 0);
        if ($scope.link === 'text') {
            $scope.preview = $scope.url;
        } else {
            $scope.preview = '<a href="' + $scope.url + '">Click here to apply</a>';
        }
    };
    var fetchAndBuildCWSURL = function (response) {
        if (response && response.data) {
            $scope.url = response.data.talemetryCwsUrlWithBidID;
            renderURL();
            //Below code is added for to display jobboard link warning message in the case of BID messing
            $scope.bidNotPresent = false;
            const urlObject = new URL($scope.preview);
            const params = new URLSearchParams(urlObject.search);
            if($scope.mode === 'existing' && angular.isDefined($scope.selectedSource) && !params.has('bid')) {
                $scope.bidNotPresent = true;
            }
        }
    };
    $scope.$watch('{dest:destination, sel:selectedSource, link:link}', function () {
        if (!$scope.requisitions.jobDetails) {
            return;
        }
         $scope.url = $window.jvUrls.forum + 'j?' + $scope.destination.value + '=' + $scope.requisitions.jobDetails.EId + '&s=' + $scope.selectedSource;
         if (window.isTalemetryCareersiteEnabled === true && angular.isDefined($scope.selectedSource) && $scope.selectedSource.trim() !== '') {
             $http({url: window.jvUrls.jhire + '/action/fetchTalemetryBid/' + $scope.requisitions.jobDetails.EId + '/' + $scope.selectedSource,
              method: 'GET'
              }).then(fetchAndBuildCWSURL);
          } else {
             renderURL();
          }
        // Fix for 6629 - ToDo: Find a better way to handle this.
        $('.jobLinkModal .ng-dirty').removeClass('ng-dirty');
    }, true);


    $scope.createJobLink = function (isAtsRmSourcesMappingEnabled) {
        $scope.sourceRequiredError = false;
        $scope.crmSourceRequiredError = false;
        if (!$scope.newSource) {
            $scope.sourceRequiredError = true;
        }
        else if (isAtsRmSourcesMappingEnabled && $scope.existingCrmSource && !$scope.selectedCrmSource) {
            $scope.crmSourceRequiredError = true;
        }
        else {
            $scope.newSource = $scope.newSource.replace(/\s+/g, '_');
            $scope.createNewSource();
        }
    };

    $scope.createNewSource = function () {
        $scope.showMessage = false;
        var bid = $scope.existingCrmSource ? $scope.selectedCrmSource?.bid : '';
        var payload = {
            jobBoardTitle: $scope.newSource,
            crmSourceBid: bid
        };
        Reqs.createJobBoardSource(JSON.stringify(payload), function(response, status) {
            if (status === 200) {
                $scope.jobLinkData.sourceType.push({
                    name: $scope.newSource
                });
                $scope.displayMessage('jobLinkSuccessMsg', i18n.REQ_DETAILS_SOURCE_CREATE_SUCCESS);
                $scope.mode = 'existing';
                $scope.selectedSource = $scope.newSource;
                $scope.newSource = '';
            } else if (response.msgInfo === 202) {
                $scope.displayMessage('jobLinkErrorMsg', i18n.REQ_DETAILS_SOURCE_CREATE_DUPLICATE);
                $scope.selectedSource = $scope.newSource;
            } else {
                $scope.displayMessage('jobLinkErrorMsg', i18n.REQ_DETAILS_SOURCE_CREATE_ERROR);
            }
        },
        function(error) {
            if (error?.data?.errorMessage?.includes('Bid should happen once per Mapping Group')) {
                $scope.displayMessage('jobLinkErrorMsg', i18n.REQ_DETAILS_CRM_SOURCE_MAPPING_DUPLICATE);
            } else {
                $scope.displayMessage('jobLinkErrorMsg', i18n.REQ_DETAILS_SOURCE_CREATE_ERROR);
            }
        });
    };

    $scope.previewLink = function () {
        $scope.showMessage = false;
        if ($scope.selectedSource && $scope.mode === 'existing') {
            window.open($scope.url, '_blank');
        } else {
            $scope.displayMessage('jobLinkErrorMsg', i18n.SELECT_SOURCE_MSG);
        }
    };

    $scope.displayMessage = function (className, msg) {
        $scope.msgClass = className;
        $scope.message = msg;
        $scope.showMessage = true;
    };

    $scope.cancel = function () {
        $scope.jobLinkModal.show = false;
        $scope.link = 'text';
        $scope.mode = 'existing';
        $scope.destination = {
            value: 'cj'
        };
        $scope.selectedSource = '';
        $scope.selectedCrmSource = '';
        $scope.existingCrmSource = true;
        $scope.sourceRequiredError = false;
        $scope.crmSourceRequiredError = false;
        $scope.msgClass = '';
        $scope.showMessage = false;
        $scope.bidNotPresent = false;
        $('#selectExistingSource').select2('val', '');
    };

    $scope.crmSourceSelect = function(params) {
        var url = window.jvUrls.jhire+'/action/crmSources';
        var pageSize = 25;
        var config = {
            id:'bid',
            minimumInputLength: 0,
            ajax: {
                url: url,
                quietMillis: 100,
                data: function(term, page){
                    var result = {
                        sourceQuery: term,
                        page: page,
                        perPage: pageSize
                    };
                    if (angular.isFunction(params)){
                        angular.extend(result, params());
                    } else if(angular.isObject(params)){
                        angular.extend(result, params);
                    }
                    return result;
                },
                results: function(data, page) {
                    var more = page * pageSize < data.crmSources?.count;
                    return {
                        results: data.crmSources?.mappedSources,
                        more: more
                    };
                }
            },
            formatResult: function(source) {
                return '<strong>' + this.formatSelection(source) + '</strong>';
            },
            formatSelection: function (source) {
                return source.bid + ' - ' + source.name ;
            },
            initSelection: function(element, callback){

                url += '?sourceQuery=' + element.val();

                $.ajax({
                    type: 'GET',
                    url: url,
                    success: function(data){
                        data = config.ajax.results(data).results;
                        if (data.length) {
                            data = data[0];
                        } else {
                            data = false;
                        }
                        callback(data);
                    }
                });
            }
        };
        return config;
    };
}
]);
